import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId: "us-west-2_GQOeF9u08", // prelude-v2
    ClientId: "395gp35e2eqq0s3pmfe0g9bv1s" // Melody
}

export default new CognitoUserPool(poolData);
